/**
 * When styling components with custom props using @emotion/styled, those props shouldn't be forwarded to the HTML element.
 *
 * @param propNames - Property names to ignore.
 */
export const ignoreStyleProps = (...propNames: PropertyKey[]) => ({
  shouldForwardProp: (prop: PropertyKey) => !propNames.includes(prop),
})
